"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _select = require("./select.style");
var _CommonComponents = require("./CommonComponents/CommonComponents");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const DefaultSelect = _a => {
  var {
      fit = 'medium',
      customNoOptionsMessage,
      disabled,
      variant = 'default',
      renderValue = 'label',
      suggestType = 'static',
      menuOpen,
      onInputValueChange,
      menuIsOpen
    } = _a,
    rest = __rest(_a, ["fit", "customNoOptionsMessage", "disabled", "variant", "renderValue", "suggestType", "menuOpen", "onInputValueChange", "menuIsOpen"]);
  return (0, _jsxRuntime.jsx)(_select.Components.StyledSelect, (0, _extends2["default"])({
    components: {
      MultiValueLabel: props => (0, _jsxRuntime.jsx)(_CommonComponents.MultiValueLabel, (0, _extends2["default"])({}, props, {
        renderValue: renderValue
      })),
      LoadingIndicator: () => (0, _jsxRuntime.jsx)(_CommonComponents.LoadingIndicator, {
        fit: fit,
        disabled: disabled
      }),
      DropdownIndicator: props => (0, _jsxRuntime.jsx)(_CommonComponents.DropdownIndicator, (0, _extends2["default"])({}, props)),
      ClearIndicator: props => (0, _jsxRuntime.jsx)(_CommonComponents.ClearIndicator, (0, _extends2["default"])({
        fit: fit,
        disabled: disabled
      }, props)),
      NoOptionsMessage: props => (0, _jsxRuntime.jsx)(_CommonComponents.NoOptionsMessage, (0, _extends2["default"])({
        customNoOptionsMessage: customNoOptionsMessage
      }, props))
    },
    classNamePrefix: "MultiSelect",
    fit: fit,
    styles: _CommonComponents.customStyles,
    isDisabled: disabled,
    menuIsOpen: suggestType === 'dynamic' ? menuOpen : menuIsOpen,
    variant: variant,
    onInputChange: onInputValueChange
  }, rest));
};
var _default = exports["default"] = DefaultSelect;